import React, { Component } from "react";
import { Menu } from "antd";
import PropTypes from "prop-types";
import { initPanels } from "../../../state/action/comAction";
const SubMenu = Menu.SubMenu;

/*
 *  数据菜单组件
 *  @class StarMenu
 *  @property openMenuArr {Array} 已展开的菜单数组
 *  @property rootSubmenuKeys {Array} 父菜单的key值数组
 *  @state menuList {Object} 用户构建菜单渲染的数据对象
 *  @state defaultSelectedkeys 默认选择的菜单key
 * */

class ExampleMenu extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
  };

  constructor(props) {
    super();
    this.props = props;
    this.rootSubmenuKeys = [];
    this.openMenuArr = [];
  }

  componentWillMount() {
    this.menuList = [
      {
        id: "demo1",
        title: "表单表格混合示例",
      },
      {
        id: "demo2",
        title: "表格点击功能",
      },
      {
        id: "demo4",
        title: "表格控件多处复用",
      },
      {
        id: "demo5",
        title: "多重Modal弹窗",
      },
      {
        id: "demo6",
        title: "动态生成TABLE",
      },
    ];
    this.getUserMenuList();
  }

  // 获取菜单列表数据

  getUserMenuList() {
    this.getDefaultPage(this.menuList[0]);
  }

  // 返回默认首页

  getDefaultPage(page) {
    if (page) {
      if (page.childList) {
        const p = page.childList[0];
        this.openMenuArr.push(page.id);
        this.getDefaultPage(p);
      } else {
        // 设置默认初始tab
        const tab = [
          { title: page.title, content: this.props.Frame[page.id], key: page.id, closable: false },
        ];
        const pageId = page.id;
        this.selectedkeys = [page.id];
        this.defaultopenkeys = this.openMenuArr;
        this.openkeys = this.openMenuArr;
        // 更新Panels数组状态
        this.context.store.dispatch(initPanels("demo", tab, pageId));
      }
    }
  }

  // 根据数据构建菜单

  generateMenu(menuArr) {
    const menuDom = [];
    if (menuArr) {
      for (const m of menuArr) {
        if (!m.childList) {
          menuDom.push(
            <Menu.Item key={m.id} uri={m.uri}>
              <span uri={m.uri}>{m.title}</span>
            </Menu.Item>,
          );
        } else {
          this.rootSubmenuKeys.push(m.id);
          menuDom.push(
            <SubMenu
              key={m.id}
              title={
                <span>
                  <span>{m.title}</span>
                </span>
              }>
              {this.generateMenu(m.childList)}
            </SubMenu>,
          );
        }
      }
      return menuDom;
    }
  }

  // 打开子菜单关闭父菜单及兄弟菜单
  onOpenChange = (openKeys) => {
    const latestOpenKey = openKeys.find((key) => this.state.openkeys.indexOf(key) === -1);
    const latestLen = latestOpenKey ? latestOpenKey.length : 0;
    const latestOpenKeyArr = [];
    for (let i = 0; i < latestLen; i += 2) {
      latestOpenKeyArr.push(latestOpenKey.substr(0, latestLen - i));
    }
    if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      this.setState({ openkeys: openKeys });
    } else {
      this.setState({
        openkeys: latestOpenKey ? latestOpenKeyArr : [],
      });
    }
  }

  render() {
    return (
      <div>
        <Menu
          className="ant-scroll-menu"
          theme="dark"
          mode="inline"
          defaultSelectedKeys={this.selectedkeys}
          openKeys={this.openkeys}
          onOpenChange={this.onOpenChange}
          onClick={this.props.addTab}>
          {this.generateMenu(this.menuList)}
        </Menu>
        ;
      </div>
    );
  }
}

export default ExampleMenu;

ExampleMenu.propsType = {
  addTab: PropTypes.func.isRequired,
  Frame: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/AntD/components/display/menu/exampleMenu.js